import { createRoot } from 'react-dom/client';

import { VoiceDemoRoot } from './component/voiceDemo/VoiceDemoRoot';
import { VoicesProvider } from './providers/VoicesProvider';

export const mountApp = (container: Element) => {
  createRoot(container).render(
    <VoicesProvider>
      <VoiceDemoRoot />
    </VoicesProvider>,
  );
};
